<template>
  <TrfGlobalLoader type="overlay" v-if="showLoaderUrl"/>
  <div class="container"> 
    <iframe src="" id="iFrameAnexo" ></iframe> 
  </div>
</template>

<script>

import router from '../../router';
import { anexoService } from '../../service/anexo-service';
import TrfGlobalLoader from "../../components/GlobalLoader"

export default {
  name: "UrlAnexo",
  components: {
    TrfGlobalLoader
  },
  props: {},
  data() {
    return {
      showLoaderUrl: false
    }
  },
  methods: {},
  mounted() {
    this.showLoaderUrl = true;
    const id = router.currentRoute.value.query.id;
    const type = router.currentRoute.value.query.type;
    const response = anexoService.visualizarById(id,type);
    response.then(() => {
      this.showLoaderUrl = false;
    });
  }
};
</script>

<style lang="scss" scoped>

#iFrameAnexo {
  width: 100%; 
  height: 100vh; 
  border: none; 
}

</style>